import {
  useCrearEstadoMovimiento,
  useEditarEstadoMovimiento,
  useListarEstadosMovimiento,
} from "../../../../Hooks/Admin";
import { CustomForm } from "../../../../Components/Admin/CustomForm";
import { CustomTable } from "../../../../Components/Admin/CustomTable";
import {
  camposFormulario,
  columns,
  formatData,
  camposFilter,
} from "./camposFormulario";

export const EstadoMovimientoForm = () => {
  return (
    <>
      <CustomForm
        camposFormulario={camposFormulario}
        querySubmit={useCrearEstadoMovimiento}
      />
    </>
  );
};

export const EstadoMovimientoEditar = () => {
  return (
    <CustomTable
      camposFilter={camposFilter}
      camposFormularioModal={camposFormulario}
      queryListar={useListarEstadosMovimiento}
      queryEditar={useEditarEstadoMovimiento}
      formatData={formatData}
      columns={columns}
      editable={true}
    />
  );
};
